<footer class="bg-Navy py-3">
    <div class="mx-auto px-[24px] sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1920px] 2xl:px-[40px] 3xl:px-[120px]">
        <div class="flex flex-col md:flex-row items-center gap-6 md:gap-0 py-5">

            <!-- Columna 1: Logo -->
              <div class="flex items-center justify-center md:justify-start md:pr-8 md:border-r-2 md:border-white shrink-0">
                 <img [src]="footerImgs?.govco"
                     alt="Govco Logo"
                     class="h-28 w-auto">
                 <span class="mx-3 h-16 w-px bg-white/50"></span>
                 <img [src]="footerImgs?.cic"
                     alt="CIC Logo"
                     class="h-28 w-auto">
              </div>

            <!-- Columna 2: Información -->
            <div class="flex-1 text-white text-center md:text-left md:pl-8">
                <p class="text-[15px] font-semibold uppercase tracking-wide">BY CIC · CREATIVE INNOVATION COMPANY</p>
                <p class="text-[14px] text-white/75 mt-1">Carrera 43 #9 Sur 195 · Edificio Square · Oficina 734</p>
                <p class="text-[14px] text-white/75">Medellín · Antioquia · Colombia</p>
            </div>

            <!-- Columna 3: Redes sociales y correo -->
            <div class="flex flex-col items-center md:items-end gap-2 shrink-0">
                <div class="flex items-center gap-2">
                    <a href="tel:+573106632165"
                       class="w-8 h-8 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                        <i class="ri-phone-line text-[14px]"></i>
                    </a>
                    <a href="mailto:tomas.p@agencycic.com"
                       class="w-8 h-8 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                        <i class="ri-mail-line text-[14px]"></i>
                    </a>
                    <a href="https://www.instagram.com/cic_agencyofficial?igsh=ZmkxZjh0ZDIxbm52" target="_blank" rel="noopener noreferrer"
                       class="w-8 h-8 rounded-full border border-white/50 flex items-center justify-center text-white hover:bg-white/20 transition-colors">
                        <i class="ri-instagram-line text-[14px]"></i>
                    </a>
                </div>
                <a href="mailto:tomas.p@agencycic.com"
                   class="text-white text-[12px] underline hover:text-white/70 transition-colors">
                    tomas.p&#64;agencycic.com
                </a>
            </div>

        </div>
    </div>
    <!-- <div class="h-[4px] bg-[#0f1e36]"></div> -->
</footer>



